




import { Component, Vue, Prop } from "vue-property-decorator";
import VueJsonPretty from "vue-json-pretty";
import "vue-json-pretty/lib/styles.css";
@Component({
  components: {
    "vue-json-pretty": VueJsonPretty
  }
})
export default class UPrettyJson extends Vue {
  // Props
  @Prop({ required: true })
  public data: any;
  @Prop({ default: 1 })
  public deep: any;
  // Computed
  public parseJSON(data) {
    try {
      return JSON.parse(data);
    } catch (e) {
      return data;
    }
  }
}
